import React from "react";
import Cancelorderpopup from "./Cancelorderpopup";
import { useState } from "react";
function SelectReturnproduct() {

  const [showpopup,setShowpopup] = useState(false);

  const handleshowpopup = ()=>{
    setShowpopup(true)
  }

  const handleclosePopup = ()=>{
    setShowpopup(false)
  }

  return (
    <section className="return_order_Section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-10">
            <div className="innber_box_one">
              <h5>Select items you need to Return</h5>
            </div>
            <div className="product_box">
              <div className="row">
                <div className="col-lg-6 grid_col">
                  <div className="inner_box">
                    <div className="select_box">
                      <input type="checkbox" />
                    </div>
                    <div className="right_box">
                      <div className="product_image">
                        <img
                          // src={Image1}
                          alt=""
                          style={{ backgroundColor: "#f4f4f4" }}
                        />
                      </div>
                      <div className="product_description">
                        <h6>Groundnut Oil, 1ltr / கடலை எண்ணெய் </h6>
                        <div style={{ display: "flex", gap: "60px" }}>
                          <span>₹ 360</span>
                          <span>Qty:2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 grid_col">
                  <div className="inner_box">
                    <div className="select_box">
                      <input type="checkbox" />
                    </div>
                    <div className="right_box">
                      <div className="product_image">
                        <img
                          // src={Image1}
                          alt=""
                         
                        />
                      </div>
                      <div className="product_description">
                        <h6>Groundnut Oil, 1ltr / கடலை எண்ணெய் </h6>
                        <div style={{ display: "flex", gap: "60px" }}>
                          <span>₹ 360</span>
                          <span>Qty:2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 grid_col">
                  <div className="inner_box">
                    <div className="select_box">
                      <input type="checkbox" />
                    </div>
                    <div className="right_box">
                      <div className="product_image">
                        <img
                          // src={Image1}
                          alt=""
                        
                        />
                      </div>
                      <div className="product_description">
                        <h6>Groundnut Oil, 1ltr / கடலை எண்ணெய் </h6>
                        <div style={{ display: "flex", gap: "60px" }}>
                          <span>₹ 360</span>
                          <span>Qty:2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 grid_col">
                  <div className="inner_box">
                    <div className="select_box">
                      <input type="checkbox" />
                    </div>
                    <div className="right_box">
                      <div className="product_image">
                        <img
                          // src={Image1}
                          alt=""

                        />
                      </div>
                      <div className="product_description">
                        <h6>Groundnut Oil, 1ltr / கடலை எண்ணெய் </h6>
                        <div style={{ display: "flex", gap: "60px" }}>
                          <span>₹ 360</span>
                          <span>Qty:2</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="inner_box_two">
              <div>
                <h6>3 Items</h6>
                <ul>
                  <li>
                    Coconut Oil, 1ltr / தேங்காய் எண்ணெய் (Qty: 2, price:720)
                  </li>
                  <li>
                    Groundnut Oil, 1ltr / கடலை எண்ணெய் (Qty: 1, price:390)
                  </li>
                </ul>
              </div>
              <div>
                <button className="btn_1_1" onClick={handleshowpopup} >Return</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showpopup ? <Cancelorderpopup onClose={handleclosePopup} /> : null }
    </section>
  );
}

export default SelectReturnproduct;
